"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headlessOption = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DEFAULT = true;
let headlessMode = DEFAULT;
const cliFlag = 'disable-headless';
exports.headlessOption = {
    name: 'Disable Headless Mode',
    cliFlag,
    description: () => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "If disabled, the render will open an actual Chrome window where you can see the render happen. The default is headless mode." })),
    ssrName: 'headless',
    docLink: 'https://www.remotion.dev/docs/chromium-flags#--disable-headless',
    type: false,
    getValue: ({ commandLine }) => {
        if (commandLine[cliFlag] !== undefined) {
            return {
                source: 'cli',
                value: !commandLine[cliFlag],
            };
        }
        if (headlessMode !== DEFAULT) {
            return {
                source: 'config',
                value: headlessMode,
            };
        }
        return {
            source: 'default',
            value: headlessMode,
        };
    },
    setConfig: (value) => {
        headlessMode = value;
    },
};
